import { ASSET_TYPES, AssetType } from "../../../services/instruments";
import { CatalogFilters, FilterOption, PriceFilter } from "./types";

export const INSTRUMENT_SEARCH_MAX_LENGTH = 100;
export const INSTRUMENT_SEARCH_DEBOUNCE_MS = 300;

export const DEFAULT_FILTERS: CatalogFilters = {
  query: "",
  assetType: "all",
  price: "all",
};

const ASSET_TYPE_LABELS: Record<AssetType, string> = {
  STOCK: "Stock",
  ETF: "ETF",
  CRYPTO: "Crypto",
  FOREX: "Forex",
  OTHER: "Other",
};

export const ASSET_TYPE_OPTIONS: FilterOption<AssetType | "all">[] = [
  { value: "all", label: "All types" },
  ...ASSET_TYPES.map((value) => ({ value, label: ASSET_TYPE_LABELS[value] })),
];

export const PRICE_OPTIONS: FilterOption<PriceFilter>[] = [
  { value: "all", label: "All prices" },
  { value: "stale", label: "Stale" },
];

export const NO_PRICE_LABEL = "No price recorded";
